






















































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  VideoPointData, emptyPoint, getConnectProtocol, getStorageTypeList,
  getPointInfo, putPointData, getStreamMode
} from '@/api/videoDevice/index'
import { getLookupByType, DDLItem, DDL2Item } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { mergeDegrees, splitDegrees } from '@/configs/functions'
import { validateFloat, validateInt, validateIntKey, validateDegree, validateMinuteSecond, showVaildMsg } from '@/configs/validate'
import Element from 'element-ui'
import FormDialog from '@/components/dialog/formDialog.vue'
// import PointInMap from '@/components/pointInMap.vue'

const getFormRules = (form: { [key: string]: string | any }) => {
  return {
    PointName: [{ required: true, message: '请输入监控点名称', trigger: 'blur' }],
    PointNumber: [{ required: true, message: '请输入监控点编号', trigger: 'blur' }],
    StorageType: [
      { required: true, validator: validateIntKey('请选择录像存储位置'), trigger: 'change' }
    ],
    PointType: [
      { required: true, validator: validateIntKey('请选择监控点类型'), trigger: 'change' }
    ],
    ConnectProtocol: [
      { required: true, message: '请选择连接协议', trigger: 'change' }
    ],
    ChannelNumber: [{ required: true, message: '请输入通道编号', trigger: 'blur' }],
    ChannelType: [
      { required: true, validator: validateIntKey('请选择通道类型'), trigger: 'change' }
    ],
    LngDegree: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateDegree, tag: 'Lng', trigger: 'blur' }
    ],
    LngMinute: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    LngSecond: [
      { validator: validateFloat, message: '请输入数字', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    LatDegree: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateDegree, tag: 'Lat', trigger: 'blur' }
    ],
    LatMinute: [
      { validator: validateInt, message: '请输入整数', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    LatSecond: [
      { validator: validateFloat, message: '请输入数字', trigger: 'blur' },
      { validator: validateMinuteSecond, trigger: 'blur' }
    ],
    SeaHeight: [
      { type: 'number', message: '必须为数字', trigger: 'blur' }
    ]
  }
}
interface coordData {
  Degree: number
  Minute: number
  Second: number
}
@Component({
  components: {
    FormDialog
  }
})
export default class VideoPointForm extends Vue {
  public name = 'VideoPointForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false
  public expandNames: string[] = ['info']
  public loading = false
  public firstType: number = enFirstType.Select

  public form = Object.assign({}, emptyPoint)
  public storageTypeList: DDLItem[] = []
  public pointTypeList: DDLItem[] = []
  public potocolList: DDL2Item[] = []
  public channelTypeList: DDLItem[] = []
  public streamModeList: DDLItem[] = []
  // #endregion
  public rules: any = getFormRules(this.form)
  // dynamic component
  public $refs!: {
    formData: Element.Form
  }
  public created() {
  }
  public mounted() {
    window.eventBus.$on(
      'openVideoPointForm',
      (info: { videoId: number; dataId: number }) => {
        if (info.videoId == 0 && info.dataId == 0) {
          this.$message({
            message: '未找到设备信息',
            type: 'warning'
          })
        }
        else {
          this.open()
          this.fetchSource()
          this.fetchData(info)
        }
      }
    )
  }
  public beforeDestroy() {
    window.eventBus.$off('openVideoPointForm')
  }
  public openMap() {
    const f = Object.assign({}, this.form)
    const lng = mergeDegrees(f.LngDegree, f.LngMinute, f.LngSecond)
    const lat = mergeDegrees(f.LatDegree, f.LatMinute, f.LatSecond)
    if (lng == 0 || lat == 0) {
      this.$message({
        message: `请输入经纬度`,
        type: 'warning'
      })
      return false
    }
    f.Longitude = lng
    f.Latitude = lat
    // lng = 116.404
    // lat = 39.915
    var title = f.PointName + '监控点坐标预览'
    var points = [{ Longitude: lng, Latitude: lat, Online: f.Online, PointName: f.PointName }]
    const data: { points: any, title: string } = {
      points: points,
      title: title
    }
    window.eventBus.$emit('openCameraCoordPreview', data)
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchSource() {
    if (this.pointTypeList.length == 0) {
      getLookupByType(enLookupType.VideoPointType, this.firstType).then(
        (response: { data: any }) => {
          this.pointTypeList = response.data
        }
      )
    }
    if (this.potocolList.length == 0) {
      getConnectProtocol(this.firstType).then(
        (response: { data: any }) => {
          this.potocolList = response.data
        }
      )
    }
    if (this.storageTypeList.length == 0) {
      getStorageTypeList(this.firstType).then(
        (response: { data: any }) => {
          this.storageTypeList = response.data
        }
      )
    }
    if (this.channelTypeList.length == 0) {
      getLookupByType(enLookupType.VideoChannelType, this.firstType).then(
        (response: { data: any }) => {
          this.channelTypeList = response.data
        }
      )
    }
    if (this.streamModeList.length == 0) {
      getStreamMode(enFirstType.None).then(
        (response: { data: any }) => {
          this.streamModeList = response.data
        }
      )
    }
  }
  public fetchData(info: { videoId: number; dataId: number }) {
    this.form = Object.assign({}, emptyPoint)
    this.loading = true
    const id = info.dataId
    getPointInfo(id)
      .then((response: { data: any }) => {
        let f = response.data
        if (f.Id == 0) {
          f = Object.assign({}, emptyPoint)
          f.VideoId = info.videoId
        }
        var lng = splitDegrees(f.Longitude)
        f.LngDegree = lng.d
        f.LngMinute = lng.m
        f.LngSecond = lng.s
        var lat = splitDegrees(f.Latitude)
        f.LatDegree = lat.d
        f.LatMinute = lat.m
        f.LatSecond = lat.s
        this.form = Object.assign({}, f)
        this.rules = getFormRules(this.form)
        this.$nextTick(() => {
          if (this.$refs.formData) {
            this.$refs.formData.clearValidate()
          }
        })
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public sendData(data: VideoPointData) {
    window.eventBus.$emit('submitVideoPointForm', {
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        const lng = mergeDegrees(f.LngDegree, f.LngMinute, f.LngSecond)
        const lat = mergeDegrees(f.LatDegree, f.LatMinute, f.LatSecond)
        if (lng == 0 || lat == 0) {
          this.$message({
            message: `请输入经纬度`,
            type: 'warning'
          })
          return false
        }
        f.Longitude = lng
        f.Latitude = lat
        putPointData(f.VideoId, f).then(
          (response: { data: any }) => {
            const data = response.data
            const msg = f.Id > 0 ? '保存' : '创建'
            if (data && !data.IsError) {
              this.$message({
                message: `${msg}成功`,
                type: 'success'
              })
              this.sendData(f)
              this.close()
            } else {
              this.$message({
                dangerouslyUseHTMLString: true, message: `${data.Message}`,
                type: 'warning'
              })
              console.log(response)
            }
          },
          (data: any) => {
            console.log(data)
          }
        )
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}